export const DEFAULT_DISPLAY_CURRENCY_CODE = 'USD';

export const DISPLAY_CURRENCIES = Object.freeze([
    { code: 'USD', symbol: '$', labelKey: 'personal.usd', enabled: true, sort: 1 },
    { code: 'TWD', symbol: 'NT$', labelKey: 'personal.twd', enabled: true, sort: 2 },
    { code: 'HKD', symbol: 'HK$', labelKey: 'personal.hkd', enabled: true, sort: 3 },
    { code: 'MOP', symbol: 'MOP$', labelKey: 'personal.mop', enabled: true, sort: 4 },
    { code: 'EUR', symbol: '€', labelKey: 'personal.eur', enabled: true, sort: 5 },
    { code: 'RUB', symbol: '₽', labelKey: 'personal.rub', enabled: true, sort: 6 },
    { code: 'KRW', symbol: '₩', labelKey: 'personal.krw', enabled: true, sort: 7 },
    { code: 'PHP', symbol: '₱', labelKey: 'personal.php', enabled: true, sort: 8 },
    { code: 'JPY', symbol: '¥', labelKey: 'personal.jpy', enabled: true, sort: 9 },
    { code: 'THB', symbol: '฿', labelKey: 'personal.thb', enabled: true, sort: 10 },
    { code: 'TRY', symbol: '₺', labelKey: 'personal.try', enabled: true, sort: 11 },
    { code: 'VND', symbol: '₫', labelKey: 'personal.vnd', enabled: true, sort: 12 },
    { code: 'GBP', symbol: '£', labelKey: 'personal.gbp', enabled: true, sort: 13 },
    { code: 'CNY', symbol: '¥', labelKey: 'personal.cny', enabled: true, sort: 14 },
    { code: 'INR', symbol: '₹', labelKey: 'personal.inr', enabled: true, sort: 15 },
].map((currency) => Object.freeze(currency)));

const DISPLAY_CURRENCY_MAP = Object.freeze(
    DISPLAY_CURRENCIES.reduce((result, currency) => {
        result[currency.code] = currency;
        return result;
    }, {})
);

export function normalizeDisplayCurrencyCode(value) {
    let candidate = value;
    if (candidate && typeof candidate === 'object') {
        candidate = candidate.code || candidate.value || candidate.text;
    }

    if (typeof candidate !== 'string') {
        return '';
    }

    return candidate.trim().split(/\s+-\s+/)[0].toUpperCase();
}

export function findDisplayCurrency(value) {
    return DISPLAY_CURRENCY_MAP[normalizeDisplayCurrencyCode(value)] || null;
}

export function getDisplayCurrency(value = DEFAULT_DISPLAY_CURRENCY_CODE) {
    return findDisplayCurrency(value)
        || DISPLAY_CURRENCY_MAP[DEFAULT_DISPLAY_CURRENCY_CODE];
}

export function getDisplayCurrencyIndex(value) {
    const currency = getDisplayCurrency(value);
    return DISPLAY_CURRENCIES.findIndex((item) => item.code === currency.code);
}

export function getDisplayCurrencyText(value) {
    const currency = getDisplayCurrency(value);
    return `${currency.code} - ${currency.symbol}`;
}

export function createDisplayCurrencyStorageValue(value) {
    const currency = getDisplayCurrency(value);
    return {
        text: currency.code,
        value: currency.code,
        symbol: currency.symbol,
    };
}
